<template>
  <td v-if="renderCell && isEditable" :class="className" @click="cellclick">
    <base-el-select ref="cellinput" class="w-full" v-model="localValue" :options="options" size="mini" tabindex="0" @change="change" @blur="blur" />
  </td>
  <td v-else-if="renderCell" :class="className" @click="cellclick">{{ value }}</td>
  <td v-else-if="renderArrow" :key="'g' + columnIndex" :class="'k-group-cell'" />
  <td v-else-if="columnIndex <= level" key='g-colspan' :colSpan="columnsCount - columnIndex">
    <p class='k-reset'>
      <a @click="onGroupClick" tabIndex='-1' href='#' :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import { i18n } from '@/i18n'
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'

export default {
  name: 'enum-template',
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      defaultEnumId: ['id', 'key'],
      defaultEnumValue: ['value', 'name', 'Nombre'],
      localValue: ''
    }
  },
  mounted () {
    this.localValue = this.value
    if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
      this.$refs.cellinput.focus()
      this.$refs.cellinput.open()
    }
  },
  watch: {
    idValue: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    inEdit: function () {
      return getNestedValue(this.editField, this.dataItem) === true
    },
    finalFormats: function () {
      const formats = this.isJSONArray(this.format) ? JSON.parse(this.format) : [this.format]
      return formats.reduce((acc, format) => ({ ...acc, [format]: this.$store.getters[`config/${format}`] }), {})
    },
    options: function () {
      return Object.values(this.finalFormats).filter(x => x).flat()
    },
    value: function () {
      if (this.format?.length && (!this.ignoreNull || ![null, undefined].includes(this.idValue))) {
        const formats = Object.entries(this.finalFormats)
        const warns = []
        for (const [format, myenum] of formats) {
          if (myenum) {
            const enumItem = myenum.find(x => this.searchValue(x, [this.idEnumField, ...this.defaultEnumId]) === this.idValue)
            const enumValue = this.searchValue(enumItem, [this.valueEnumField, ...this.defaultEnumValue])
            if (enumValue) {
              return enumValue
            } else {
              warns.push(i18n.t('feedback.warning.bad_conf_enum_value_warn', { field: this.field, config: format, value: this.idValue })) 
            }
          } else {
            console.error(i18n.t('feedback.error.bad_enum_config_error', { field: this.field, config: format }))
          }
        }
        warns.forEach(warn => console.warn(warn))
      }
      return this.idValue
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return value
    },
    idValue: function () {
      return getNestedValue(this.field, this.dataItem)
    },
    idEnumField: function () {
      return this.extraparams?.idEnum
    },
    valueEnumField: function () {
      return this.extraparams?.valueEnum
    },
    ignoreNull: function () {
      return this.extraparams?.ignoreNull ?? true
    },
    editable: function () {
      return !!this.extraparams.editable
    },
    isCellEditable: function () {
      return this.editType === 'cell'
    },
    isEditable: function () {
      return this.editable && this.inEdit && (!this.isCellEditable || this.curEditField === this.field)
    }
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    onGroupClick (e) {
      // @ts-ignore
      this.$emit('groupclick', e, this.dataItem, this.expanded)
    },
    change (value) {
      var dataItem, field
      if (typeof value === 'object' &&
        Object.hasOwnProperty.call(value, 'dataItem') &&
        Object.hasOwnProperty.call(value, 'field') &&
        Object.hasOwnProperty.call(value, 'value')) {
        ({ dataItem, field, value } = value)
      } else {
        dataItem = this.dataItem
        field = this.field
      }
      this.$emit('change', { dataItem, field, value })
    },
    blur (e) {
      if (this.idValue !== this.localValue) {
        this.change(this.localValue)
      }
      this.$emit('blur', e)
    },
    cellclick (e) {
      this.$emit('cellclick', { dataItem: this.dataItem, field: this.field, event: e })
    },
    searchValue (item, keys = [], falsys = [undefined]) {
      if (item !== null && item !== undefined) {
        if (!keys.length) {
          return item
        }
        for (const key of keys) {
          if (key) {
            const value = getNestedValue(key, item)
            if (!falsys.includes(value)) {
              return value
            }
          }
        }
      }
      return undefined
    },
    isJSONArray: function (value) {
      try {
        return Array.isArray(JSON.parse(value))
      } catch {
        return false
      }
    }
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
